export default {
  sorry: 'Nous sommes désolés',
  doNotQualify: 'Les conditions minimales ne sont pas rencontrées, vous ne vous qualifiez pas pour ce produit.',
  getInTouch: 'Veuillez prendre contact avec un conseiller.',
  confirmation: {
    title: 'Merci!',
  },
};
